import React from 'react'
import PropTypes from 'prop-types'
import styles from './Skeleton.module.scss'

const cx = (...p) => p.filter(Boolean).join(' ')

const Skeleton = ({ width, height, shape = 'rect', className, ...rest }) => (
  <span
    className={cx(styles.skeleton, shape === 'text' && styles.text, shape === 'circle' && styles.circle, className)}
    style={{ width, height }}

    aria-hidden="true"
    {...rest}
  />
)

Skeleton.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  shape: PropTypes.oneOf(['rect', 'text', 'circle']),
  className: PropTypes.string,
}

export const SkeletonText = ({ lines = 3, className }) => (
  <span className={cx(styles.stack, className)} aria-hidden="true">
    {Array.from({ length: lines }).map((_, i) => (
      <Skeleton key={i} shape="text" width={i === lines - 1 ? '60%' : '100%'} />
    ))}
  </span>
)

SkeletonText.propTypes = {
  lines: PropTypes.number,
  className: PropTypes.string,
}

export default Skeleton
